import type { ReactNode } from 'react';
import { useFormContext } from 'react-hook-form';

import type { TextReadOnlyFieldConfig } from '../../config';
import { LeaseTextReadOnlyInput } from '../../inputs/lease-text-input';

export type ReadOnlyFieldProps = {
  path: string;
  field: TextReadOnlyFieldConfig;
  label: ReactNode;
};

// Displayed value tracks form state (seeded with `field.value` at mount via
// `collectFieldDefaults`). No `?? field.value` fallback — display and submit
// must agree, including for the edge case where a consumer explicitly
// overrides via `initialValues`.
export function ReadOnlyField({ path, label }: ReadOnlyFieldProps) {
  const { watch } = useFormContext();
  const formValue = watch(path) as string | null | undefined;
  const labelString = typeof label === 'string' ? label : '';
  return (
    <LeaseTextReadOnlyInput
      name={path}
      title={labelString}
      label={labelString}
      value={formValue ?? ''}
    />
  );
}
